// import custom legacy styles files
import(/* webpackChunkName: "vendors/styles/legacy" */ './legacy');

import './mixins.less';

// modular global styles
import './main.less';
import './modals.less';
import './status.less';
import './theme.less';

import './input-controls.less';
